import { useState, useEffect } from "react";

import IconButton from "../../common/IconButton";
import imgChat from "../../../icons/icon-footer1.svg";
import imgLatencion from "../../../icons/icon-footer2.svg";
import imgLatencionFree from "../../../icons/icon-footer3.svg";
import imgRelevos from "../../../icons/icon-footer4.svg";
import imgIntranet from "../../../icons/icon-footer5.svg";
import imgRadio from "../../../icons/imgs_gov1.png";
import imgCorreo from "../../../icons/imgs_gov2.png";
import imgAsocCol from "../../../icons/imgs_gov3.png";
import imgGobiernoLinea from "../../../icons/imgs_gov4.png";
import imgCodBarra from "../../../icons/imgs_gov5.png";
import imgHoraLegal from "../../../icons/imgs_gov6.png";
import imgHoraLogoFooter from "../../../icons/logo_footer.png";
import imgGovCo from "../../../icons/marca_co.png";
import imgLogGobCo from "../../../icons/logo_gov.png";
import logo_nav_footer from "../../../icons/logo_nav_footer.png";

import getDatos from "../../../services/getDatos";

export default function PiePagina() {
  return (
    <>
      {/*encabezado del footer de la alcaldía de medellín (acércate a la alcaldía de medellín)*/}
      <div className="cabeza-footer">
        <div className="content-acercate">
          <br />
          <h2 className="lbl-acercate">Acércate a la Alcaldía de Medellín</h2>
        </div>
        <div className="content-logoalcaldia">
          <a href="https://www.medellin.gov.co/es" rel="noreferrer">
            <img
              width="601"
              height="416"
              className="logo_alacaldi_footer"
              src={imgHoraLogoFooter}
              alt=""
            />
          </a>
        </div>
      </div>
      {/*footer principal alcaldía de medellín*/}
      <footer>
        <div className="content-footer">
          <div className="horarios">
            <div className="grid">
              <h3 className="titulo_horarios_">
                Centro Administrativo Distrital:
              </h3>
              <p>
                Lunes a Jueves de 7:30 a. m. a 12:00 m. y de 1:30 p. m. a 5:00
                p. m<br />
                Viernes de 7:30 a. m. a 12:00 m. y de 1:30 p. m. a 4:00 p. m.
              </p>

              <h3 className="titulo_horarios_">
                Oficinas de Servicios Tributarios La Alpujarra:
              </h3>
              <p>
                Lunes a Jueves de 7:30 a. m. a 5:00 p. m. y viernes de 7:30 a.
                m. a 4:00 p. m.
              </p>

              <h3 className="titulo_horarios_">
                Centro de Servicios a la Ciudadanía La Alpujarra - Sótano:
              </h3>
              <p>
                Lunes a Jueves de 7:30 a. m. a 5:30 p. m. y Viernes de 7:30 a.
                m. a 4:30 p. m. (jornada continua).
              </p>

              <h3 className="titulo_horarios_">Dirección:</h3>
              <p>
                Calle 44 # 52 - 165, Centro Administrativo La Alpujarra,
                Medellín, Colombia
              </p>

              <h3 className="titulo_horarios_">Correo Portal:</h3>
              <p>
                <a href="https://www.medellin.gov.co/es/pqrsd/">Contáctenos</a>
              </p>

              <br />
              <div className="otros_link_footer">
                <a href="https://www.medellin.gov.co/es/sedes/">
                  Conoce todas las sedes, puntos y horarios de atención
                </a>
                <br />
                <a href="https://www.medellin.gov.co/es/pqrsd/">Contáctanos</a>
              </div>
            </div>
            <div className="content-redes">
              <div className="content-rede-hijo">
                <h3 className="head_listred_">Redes Sociales</h3>
                <h4 className="titulo_redD_">Alcaldía de Medellín</h4>
                <div className="content-redepadre">
                  <span className="radius-img">
                    <IconButton className="icono-twitter" />
                  </span>
                  <span className="radius-img">
                    <IconButton className="icono-facebook" />
                  </span>
                  <span className="radius-img">
                    <IconButton className="icono-instagram" />
                  </span>
                  <span className="radius-img">
                    <IconButton className="iconyoutube" />
                  </span>
                  <span className="radius-img">
                    <IconButton className="icono-vimeo" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-hijo-footer">
          <div className="contentfotterhijo-hijo">
            <h3 className="lblhijos-footer">Centro documental:</h3>
            <p className="color_white">
              <a
                rel="noreferrer"
                className="color_white"
                href="https://www.medellin.gov.co/es/centro-documental/"
                target={"_blank"}
              >
                Centro documental:
              </a>
              <a
                className="color_white"
                href="https://medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/458-Publicaciones-citaciones-comunicaciones-y-notificaciones"
                target="_blank"
                rel="noreferrer"
              >
                Citaciones
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/458-Publicaciones-citaciones-comunicaciones-y-notificaciones"
                target="_blank"
              >
                Comunicaciones
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/458-Publicaciones-citaciones-comunicaciones-y-notificaciones"
                target="_blank"
              >
                Notificaciones
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://medellin.gov.co/irj/portal/medellin/consulnoti"
                target="_blank"
              >
                Notificaciones por actos administrativos
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/secretaria-general/proyectos-normativos-agenda-regulatoria/"
              >
                Proyectos normativos y agenda regulatoria
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://csc.medellin.gov.co/APRUsers/#!/login/"
                target="_blank"
              >
                Soporte al servidor público
              </a>
            </p>
            <br />
            <h3 className="lblhijos-footer">Ayudas:</h3>
            <p className="color_white">
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/es/soporte-al-servidor-publico/"
              >
                Correo remoto
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/preguntas-frecuentes/"
              >
                Preguntas frecuentes
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=navurl://4fe61ddd921db378550e7d4269698f86"
              >
                Encuesta de satisfacción
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/soporte-al-servidor-publico/"
              >
                Gestionar usuario
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/glosario-de-la-alcaldia-de-medellin/"
              >
                Glosario
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/manuales-de-identidad-corporativa/"
              >
                Manual de identidad gráfica
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/9652-Monitoreo-y-desempeno-del-sitio"
              >
                Monitoreo y desempeño del sitio
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/mapa-del-sitio/"
              >
                Mapa del Sitio
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://mercurio.medellin.gov.co/mercurio/servlet/ValidarUsuarioLdap"
                target="_blank"
              >
                Sistema de Gestión Documental - SGD Mercurio
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/9261-Que-es-el-POT"
                target="_blank"
              >
                P.0.T
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://www.medellin.gov.co/irj/go/km/docs/documents/ServiciosLinea/DocumentosContratacion/MANUAL2009.pdf"
                target="_blank"
              >
                Manual de contratación
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="http://bit.ly/2YMax5W"
                target="_blank"
              >
                Antes de salir de casa
              </a>
            </p>
          </div>
          <div className="content-hijo-footer">
            <h3 className="lblhijos-footer">Políticas:</h3>
            <p className="color_white">
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/transparencia/politica-de-tratamientos-de-datos/"
              >
                Política de tratamiento de datos, uso del portal, cookies y
                privacidad
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                rel="noreferrer"
                href="https://www.medellin.gov.co/irj/go/km/docs/pccdesign/medellin/Temas/AtencionCiudadana_0/InformacinGeneral/Shared%20Content/Documentos/carta%20de%20derechos%20y%20deberes%202019.pdf"
                target="_blank"
              >
                Carta de trato digno a la ciudadanía
              </a>{" "}
              /{" "}
              <a
                className="color_white"
                href="https://www.medellin.gov.co/es/centro-documental/"
              >
                Publicaciones
              </a>{" "}
              /{" "}
              <a
                rel="noreferrer"
                className="color_white"
                href="https://datos.gov.co/"
                target="_blank"
              >
                Datos abiertos
              </a>
            </p>
            <br />
            <br />
            <p className="color_white">
              © 2022 / NIT: 890905211-1 / Código DANE: 05001 / Código Postal:
              050015 / Medellín Distrito de Ciencia, Tecnología e Innovación
            </p>
            <p className="color_white">
              Fecha de actualización: Martes 23 de Agosto del 2022
            </p>
          </div>
        </div>
      </footer>
      {/* canales de atención alcaldía de medellín*/}
      <div className="cotent-piefooter">
        <div className="contendor-centrado-lineasatenacio">
          <div className="asistencia">
            <div className="cursor">
              <img
                className="img-iconos-atencion"
                width="56"
                height="51"
                src={imgChat}
                alt=""
              />
              <span className="titles-asistencia">Chat</span>
              <p>
                <a
                  className="ref-styles"
                  href="https://www.medellin.gov.co/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Alcaldía de Medellín
                </a>
              </p>
            </div>
            <div className="px-5">
              <img
                className="img-iconos-atencion"
                width="48"
                height="51"
                src={imgLatencion}
                alt=""
              />
              <span className="titles-asistencia">Línea de atención</span>
              <p className="solomob">
                <p className="solomob">(604) 44 44 144</p>
              </p>
            </div>
            <div className="px-5">
              <img
                className="img-iconos-atencion"
                width="51"
                height="51"
                src={imgLatencionFree}
                alt=""
              />
              <span className="titles-asistencia">Línea Gratuita Nacional</span>
              <p className="solomob">
                <p className="ref-styles">01 8000 411 144</p>
              </p>
            </div>
            <div className="cursor">
              <a
                rel="noreferrer"
                className="ref-styles"
                href={
                  "https://web.emtelco.co/webrtcdemo/centro_relevos_mmed_VC/home.html"
                }
                target="_blank"
              >
                <img
                  className="img-iconos-atencion"
                  width="62"
                  height="50"
                  src={imgRelevos}
                  alt=""
                />
              </a>
              <span className="titles-asistencia">Centro de Relevos</span>
              <p>
                <a
                  rel="noreferrer"
                  className="ref-styles"
                  href="https://web.emtelco.co/webrtcdemo/centro_relevos_mmed_VC/home.html"
                  target="_blank"
                >
                  Atención por lengua de señas
                </a>
              </p>
            </div>
            <div className="cursor">
              <a
                rel="noreferrer"
                href="https://www.medellin.gov.co/irj/portal/eureka"
                target="_blank"
              >
                <img
                  className="img-iconos-atencion"
                  width="31"
                  height="51"
                  src={imgIntranet}
                  alt=""
                />
              </a>
              <span className="titles-asistencia">Intranet</span>
              <p>
                <a
                  rel="noreferrer"
                  className="ref-styles"
                  href="https://www.medellin.gov.co/irj/portal/eureka"
                  target="_blank"
                >
                  Intranet
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/*medios de comunicación*/}
      <div className="medios-comunicacion">
        <a
          rel="noreferrer"
          href="https://medellin.gov.co/irj/portal/medellin?NavigationTarget=contenido/6673-Radio-institucional"
        >
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgRadio}
            alt="Radio institucional"
          />
        </a>
        <a
          rel="noreferrer"
          href="https://correo.medellin.gov.co/owa"
          target="_blank"
        >
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgCorreo}
            alt=""
          />
        </a>
        <a rel="noreferrer" href="https://www.asocapitales.co/" target="_blank">
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgAsocCol}
            alt=""
          />
        </a>
        <a
          rel="noreferrer"
          href="http://estrategia.gobiernoenlinea.gov.co/623/w3-channel.html"
          target="_blank"
        >
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgGobiernoLinea}
            alt=""
          />
        </a>
        <a
          rel="noreferrer"
          href="http://www.colombiacompra.gov.co/"
          target="_blank"
        >
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgCodBarra}
            alt=""
          />
        </a>
        <a rel="noreferrer" href="http://horalegal.inm.gov.co/" target="_blank">
          <img
            className="img-medios"
            width="120"
            height="50"
            src={imgHoraLegal}
            alt=""
          />
        </a>
      </div>
      {/*barra gov final footer*/}
      <div className="footer-barragov-final">
        <div className="contenthijo-baarragov-footer">
          <div className="icon-alcaldia-barragov-footer">
            <a
              rel="noreferrer"
              href="https://www.medellin.gov.co/es"
              target="_blank"
            >
              <img
                className="log_nww_footer img-logo-alcaldia"
                src={logo_nav_footer}
                alt="Alcaldía de Medellín"
              />
            </a>
          </div>
          <div className="logo-govco-footer-content">
            <img className="log-co" src={imgGovCo} alt="Marca.co" />
            <a rel="noreferrer" href="https://www.gov.co/" target="_blank">
              <img className="log-govco" src={imgLogGobCo} alt="Gov.co" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
